import { prod } from './prod'
import { dev } from './dev'

const site = {
    prod,
    dev
};

export default site;